import { IdinDemoPageComponent } from './pages/idin-demo-page/idin-demo-page.component';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from './services/authGuard';
import { ConfigGuard } from './services/configGuard';
import { PageNotFoundComponent } from './pages/page-not-found/page-not-found.component';
import { ConfigurationPageComponent } from './pages/configuration-page/configuration-page.component';
import { PendingChangesGuard } from './services/PendingChangesGuard';
import { IdinVerificationIssuerResponsePageComponent } from './pages/idin-verification-issuer-response-page/idin-verification-issuer-response-page.component';
import { IdinVerificationFailedPageComponent } from './pages/idin-verification-failed-page/idin-verification-failed-page.component';
import { IdinVerificationErrorPageComponent } from './pages/idin-verification-error-page/idin-verification-error-page.component';
import { IdinVerificationCancelledPageComponent } from './pages/idin-verification-cancelled-page/idin-verification-cancelled-page.component';

import { CalculationPageResolverComponent } from './components/routing-resolvers/calculation-page-resolver/calculation-page-resolver';
import { ApplicationPageResolverComponent } from './components/routing-resolvers/application-page-resolver/application-page-resolver';

const routes: Routes = [
  {
    path: ':productType/application',
    component: ApplicationPageResolverComponent,
    canActivate: [ConfigGuard],
  },
  {
    path: ':productType/calculation',
    component: CalculationPageResolverComponent,
    canActivate: [ConfigGuard], 
  },
  {
    path: ':productType/calculation/:intermediaryId',
    component: CalculationPageResolverComponent,
    canActivate: [ConfigGuard],
  },
  {
    path: 'configuration',
    component: ConfigurationPageComponent,
    canDeactivate: [PendingChangesGuard],
    canActivate: [AuthGuard],
  },
  {
    path: 'idinVerificationIssuerResponse',
    component: IdinVerificationIssuerResponsePageComponent,
  },
  {
    path: 'idinVerificationCancelled',
    component: IdinVerificationCancelledPageComponent,
  },
  {
    path: 'idinVerificationError',
    component: IdinVerificationErrorPageComponent,
  },
  {
    path: 'idinVerificationFailed',
    component: IdinVerificationFailedPageComponent,
  },
  {
    path: 'idinDemo',
    component: IdinDemoPageComponent,
  },
  {
    path: ':productType',
    component: CalculationPageResolverComponent, // calculate will be default
    canActivate: [ConfigGuard],
  },
  // Support for locale in the URL, mostly for development and/or testing
  {
    path: ':locale/:productType/application',
    component: ApplicationPageResolverComponent,
    canActivate: [ConfigGuard],
  },
  {
    path: ':locale/:productType/calculation',
    component: CalculationPageResolverComponent,
    canActivate: [ConfigGuard], 
  },
  {
    path: ':locale/:productType/calculation/:intermediaryId',
    component: CalculationPageResolverComponent,
    canActivate: [ConfigGuard],
  },
  {
    path: ':locale/configuration',
    component: ConfigurationPageComponent,
    canDeactivate: [PendingChangesGuard],
    canActivate: [AuthGuard],
  },
  {
    path: ':locale/:productType',
    component: CalculationPageResolverComponent, // calculate will be default
    canActivate: [ConfigGuard],
  },
  {
    path: '**',
    component: PageNotFoundComponent,
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
  providers: [],
})
export class AppRoutingModule { }
